import React from 'react';
import { 
  getUniqueConfigGroups, 
  getConfigGroupOptions, 
  ConfigGroupSelection 
} from './registryUtils';
import { Box, Typography, RadioGroup, FormControlLabel, Radio, Tooltip, IconButton, Divider } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ConfigGroupSelectorProps {
  registry: any[];
  groupSelection: ConfigGroupSelection;
  onGroupSelectionChange: (selection: ConfigGroupSelection) => void;
}

const ConfigGroupSelector: React.FC<ConfigGroupSelectorProps> = ({
  registry,
  groupSelection,
  onGroupSelectionChange
}) => {
  const uniqueGroups = getUniqueConfigGroups(registry);
  
  if (uniqueGroups.length === 0) {
    return null; // No groups to show
  }

  const handleGroupChange = (groupKey: string, selectedCategory: string) => {
    const newSelection = { ...groupSelection };
    
    if (selectedCategory) {
      newSelection[groupKey] = selectedCategory;
    } else {
      delete newSelection[groupKey];
    }
    
    onGroupSelectionChange(newSelection);
  };

  return (
    <>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      
        {uniqueGroups.map(groupKey => {
          const options = getConfigGroupOptions(registry, groupKey);
          const selectedCategory = groupSelection[groupKey] || '';
          
          if (!options || options.length === 0) {
            return null;
          }
          
          return (
            <Box key={groupKey}>
              
              <RadioGroup
                row
                value={selectedCategory}
                onChange={(e) => handleGroupChange(groupKey, e.target.value)}
              >
                {options.map(option => (
                  <FormControlLabel
                    key={option}
                    value={option}
                    control={<Radio size="small" />}
                    label={option.replace(/_/g, ' ')}
                    sx={{ mr: 2 }}
                  />
                ))}
              </RadioGroup>
             
            </Box>
          );
        })}
        <Tooltip
          title="Selecting a configuration type will show only the relevant configurations for that type. Other configurations in the same group will be hidden and not saved."
          arrow
          placement="left"
        >
          <IconButton size="small" sx={{ p: 0.5 }}>
            <InfoOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          </IconButton>
        </Tooltip>
      </Box>
    </>
  );
};

export default ConfigGroupSelector; 